module.exports = __webpack_public_path__ + "media/images/riders/small/BROOK_MACDONALD-2ba8bf2130ac309b5c8abea8d43f18da.png";